import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Inject,
  input,
  PLATFORM_ID,
  signal,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {SearchWidgetV3StateService} from '../../services/search-widget-v3-state.service';
import {SearchWidgetFreeSearchFieldsEnum} from '../../enums/search-widget-free-search-fields.enum';
import {SearchWidgetV3ManagerService} from '../../services/search-widget-v3-manager.service';
import {SearchWidgetFiltersPageEnum} from '../../enums/search-widget-filters-page.enum';
import {SearchCategoriesV3Component} from '../search-categories-v3/search-categories-v3.component';
import {SearchPlacesV3Component} from '../search-places-v3/search-places-v3.component';

@Component({
  selector: 'app-search-widget-v3-desktop-expanded',
  templateUrl: './search-widget-v3-desktop-expanded.component.html',
  styleUrls: ['./search-widget-v3-desktop-expanded.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchWidgetV3DesktopExpandedComponent {
  public shouldFocusPlacesField = input<boolean>(false);
  public whichIsFocused = signal<SearchWidgetFreeSearchFieldsEnum>(SearchWidgetFreeSearchFieldsEnum.FREESEARCH);
  @ViewChild(SearchCategoriesV3Component) childCategories: SearchCategoriesV3Component;
  @ViewChild(SearchPlacesV3Component) childPlaces: SearchPlacesV3Component;
  protected readonly SearchWidgetFreeSearchFieldsEnum = SearchWidgetFreeSearchFieldsEnum;
  protected currentPage = signal<SearchWidgetFiltersPageEnum>(SearchWidgetFiltersPageEnum.MAIN);
  protected readonly SearchWidgetFiltersPageEnum = SearchWidgetFiltersPageEnum;
  private widgetState = inject(SearchWidgetV3StateService);
  public isSubmitButtonActive = this.widgetState.isSubmitButtonActive;
  public isDesktopSuggestionsPanelOpen = this.widgetState.isDesktopSuggestionsPanelOpen;
  public desktopCategoriesPanelOpen = this.widgetState.desktopCategoriesPanelOpen;
  public desktopPlacesPanelOpen = this.widgetState.desktopPlacesPanelOpen;
  private isSearchWidgetExpanded = this.widgetState.isSearchWidgetExpanded;
  private widgetManager = inject(SearchWidgetV3ManagerService);

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  public toggleSearchWidget() {
    this.widgetState.updateIsSearchWidgetExpanded(!this.isSearchWidgetExpanded());
    this.widgetState.updateIsDesktopSuggestionsPanelOpen(true);
    this.widgetState.updateDesktopCategoriesPanelOpenValue(false);
    this.widgetState.updateDesktopPlacesPanelOpenValue(false);
  }

  public onSubmitClick(): void {
    this.widgetManager.onSearchButtonClick();
  }

  public onFreeSearchFieldFocused(event: boolean): void {
    this.whichIsFocused.set(SearchWidgetFreeSearchFieldsEnum.FREESEARCH);
    this.widgetState.updateIsDesktopSuggestionsPanelOpen(true);
    this.widgetState.updateDesktopCategoriesPanelOpenValue(false);
    this.widgetState.updateDesktopPlacesPanelOpenValue(false);
  }

  public onPlacesFieldFocused(event: boolean): void {
    this.whichIsFocused.set(SearchWidgetFreeSearchFieldsEnum.PLACE);
    this.widgetState.updateIsDesktopSuggestionsPanelOpen(true);
    this.widgetState.updateDesktopCategoriesPanelOpenValue(false);
    this.widgetState.updateDesktopPlacesPanelOpenValue(false);
  }

  public onCategoriesClick(): void {
    this.widgetState.updateDesktopCategoriesPanelOpenValue(true);
    this.widgetState.updateIsDesktopSuggestionsPanelOpen(false);
    this.widgetState.updateDesktopPlacesPanelOpenValue(false);
  }

  public onPlacesClick(): void {
    this.widgetState.updateDesktopPlacesPanelOpenValue(true);
    this.widgetState.updateIsDesktopSuggestionsPanelOpen(false);
    this.widgetState.updateDesktopCategoriesPanelOpenValue(false);
  }
}
